import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/node_modules/@mui/icons-material/esm/PlayCircleOutline.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/node_modules/@mui/icons-material/esm/TokenOutlined.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/src/component/Card/External/Video.js");
;
import(/* webpackMode: "eager", webpackExports: ["PaperCardSize2","PaperCardSize5"] */ "/home/nawar/dev/app/src/component/Card/Paper.js");
;
import(/* webpackMode: "eager", webpackExports: ["CardTaskSize4"] */ "/home/nawar/dev/app/src/component/Card/Task.js");
;
import(/* webpackMode: "eager", webpackExports: ["ModelIcon"] */ "/home/nawar/dev/app/src/component/Icon/Model.js");
;
import(/* webpackMode: "eager", webpackExports: ["PaperIcon"] */ "/home/nawar/dev/app/src/component/Icon/Papers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/Search/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/Search/Suggestions/Filter/Chips.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/search/Filters/Chip/Publishers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/search/Filters/Chip/Sort.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/search/Filters/Chip/Stars.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/search/Filters/Chip/Task.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/search/Filters/Chip/Time.js");
;
import(/* webpackMode: "eager", webpackExports: ["SetTrendingHook"] */ "/home/nawar/dev/app/src/view/search/Hooks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/search/Results/index.js");
